export abstract class DomainError extends Error {
    constructor(message: string, public readonly details?: unknown) {
        super(message);
        this.name = new.target.name;
    }
}

export class AuthenticationError extends DomainError {}

export class AuthorizationError extends DomainError {}

export class OperationError extends DomainError {}
